// @ts-check

import { getIn } from 'formik'

/**
 * @param {string | undefined} haystack
 * @param {Record<string, unknown>} replacements
 */
const replaceVariables = (haystack, replacements) => {
  if (haystack == null) {
    return
  }

  return haystack.replace(/\{\{([^}]+)\}\}/g, (match, variableName) => {
    variableName = variableName.trim()
    const foundReplacement =
      replacements[variableName] || getIn(replacements, variableName)

    if (foundReplacement == null) {
      return match
    }

    return foundReplacement
  })
}

export default replaceVariables
